import { DaycareGoal, getAnnualReturnUsingRiskScore } from '../../../goals';
import { colorsByGoalType } from '../../../goals/colors';
import { getProgressUsingTargetAmount } from '../helpers';
import { BaseGoalConfig } from './types';

export const DAYCARE: BaseGoalConfig<DaycareGoal> = {
    iconName: 'GoalDaycare',
    color: colorsByGoalType['DAYCARE'].primary,
    defaultName: 'Childcare',
    getDescription: () => 'Where big hearts shape little minds.',
    group: 'INVEST',
    blogLink: {
        description: 'See Plenty’s guide on childcare',
        url: 'https://www.withplenty.com/blog/bringing-up-baby-tips-to-manage-childcare-expenses',
    },
    getAnnualReturn: getAnnualReturnUsingRiskScore,
    getProgress: (config) => getProgressUsingTargetAmount(config),
};
